var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.3175V3.75C12.5 2.0925 9.815 0.75 6.5 0.75C3.185 0.75 0.5 2.0925 0.5 3.75V11.25C0.5 12.9075 3.1925 14.25 6.5 14.25C6.845 14.25 7.175 14.25 7.4975 14.205C7.33468 13.7371 7.25103 13.2454 7.25 12.75V12.7125C7.01 12.75 6.7625 12.75 6.5 12.75C3.5975 12.75 2 11.625 2 11.25V9.5775C3.2075 10.1625 4.79 10.5 6.5 10.5C6.9875 10.5 7.4525 10.47 7.91 10.4175C8.30952 9.75638 8.87287 9.20953 9.54556 8.82983C10.2183 8.45012 10.9775 8.25041 11.75 8.25C12.005 8.25 12.2525 8.28 12.5 8.3175ZM11 7.8375C10.025 8.55 8.315 9 6.5 9C4.685 9 2.975 8.55 2 7.8375V5.73C3.1025 6.3525 4.7075 6.75 6.5 6.75C8.2925 6.75 9.8975 6.3525 11 5.73V7.8375ZM6.5 5.25C3.5975 5.25 2 4.125 2 3.75C2 3.375 3.5975 2.25 6.5 2.25C9.4025 2.25 11 3.375 11 3.75C11 4.125 9.4025 5.25 6.5 5.25ZM14.375 11.4375L10.8125 15L8.75 12.75L9.62 11.88L10.8125 13.0725L13.505 10.38L14.375 11.4375Z",
    fill: "#64A4A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedDatabase);
export default __webpack_public_path__ + "static/media/CheckedDatabase.83925543a2a683fa0e56b7f13e695070.svg";
export { ForwardRef as ReactComponent };